export default __webpack_public_path__ + "static/media/shelf.53d26f7e.svg";